import CallbackRegistry from './callback-registry.js';
var DispatcherImpl = /** @class */ (function () {
    function DispatcherImpl() {
        this.callbacks = new CallbackRegistry();
    }
    DispatcherImpl.prototype.bind = function (event, callback) {
        this.callbacks.add(event, callback);
        return this;
    };
    DispatcherImpl.prototype.emit = function (event, payload) {
        var callbacks = this.callbacks.get(event);
        var args = [];
        if (payload) {
            // metadata is undefined, so we only need to call the callback with data
            // if data exists
            args.push(payload);
        }
        if (callbacks && callbacks.length > 0) {
            for (var i = 0; i < callbacks.length; i++) {
                callbacks[i].fn.apply({}, args);
            }
        }
        return this;
    };
    DispatcherImpl.prototype.unbind = function (event, callback) {
        this.callbacks.remove(event, callback);
        return this;
    };
    DispatcherImpl.prototype.once = function (event, callback) {
        var _this = this;
        var cb = function (data) {
            callback(data);
            _this.unbind(event, cb);
        };
        this.bind(event, cb);
        return this;
    };
    return DispatcherImpl;
}());
export { DispatcherImpl };
